/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ElementsUserReference
 */
export interface ElementsUserReference {
    /**
     * 
     * @type {number}
     * @memberof ElementsUserReference
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserReference
     */
    readonly allowChangingPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserReference
     */
    readonly allowWanLogin?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserReference
     */
    readonly allowedFsPaths?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserReference
     */
    readonly allowedFsWritePaths?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly defaultPage?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly displayName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserReference
     */
    readonly effectivePermissions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly email?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ElementsUserReference
     */
    readonly expiry?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserReference
     */
    readonly fmBookmarks?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly fullName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserReference
     */
    readonly gid?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserReference
     */
    readonly groupPermissions?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserReference
     */
    readonly hasPassword?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserReference
     */
    readonly home?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserReference
     */
    readonly isExternal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserReference
     */
    readonly isCloud?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserReference
     */
    readonly isCloudDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserReference
     */
    readonly isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly language?: ElementsUserReferenceLanguageEnum;
    /**
     * 
     * @type {Date}
     * @memberof ElementsUserReference
     */
    readonly lastSeen?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserReference
     */
    readonly ldap?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly ldapDn?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserReference
     */
    readonly passwordChangeRequired?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserReference
     */
    readonly permissions?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserReference
     */
    readonly shaperCeiling?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserReference
     */
    readonly shaperRate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly syncId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserReference
     */
    readonly totpEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserReference
     */
    readonly uid?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly unixUsername?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserReference
     */
    readonly username?: string;
}

/**
* @export
* @enum {string}
*/
export enum ElementsUserReferenceLanguageEnum {
    En = 'en',
    Fr = 'fr',
    De = 'de',
    Ru = 'ru'
}

export function ElementsUserReferenceFromJSON(json: any): ElementsUserReference {
    return ElementsUserReferenceFromJSONTyped(json, false);
}

export function ElementsUserReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsUserReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'allowChangingPassword': !exists(json, 'allow_changing_password') ? undefined : json['allow_changing_password'],
        'allowWanLogin': !exists(json, 'allow_wan_login') ? undefined : json['allow_wan_login'],
        'allowedFsPaths': !exists(json, 'allowed_fs_paths') ? undefined : json['allowed_fs_paths'],
        'allowedFsWritePaths': !exists(json, 'allowed_fs_write_paths') ? undefined : json['allowed_fs_write_paths'],
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'defaultPage': !exists(json, 'default_page') ? undefined : json['default_page'],
        'displayName': !exists(json, 'display_name') ? undefined : json['display_name'],
        'effectivePermissions': !exists(json, 'effective_permissions') ? undefined : json['effective_permissions'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'expiry': !exists(json, 'expiry') ? undefined : (json['expiry'] === null ? null : new Date(json['expiry'])),
        'fmBookmarks': !exists(json, 'fm_bookmarks') ? undefined : json['fm_bookmarks'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
        'groupPermissions': !exists(json, 'group_permissions') ? undefined : json['group_permissions'],
        'hasPassword': !exists(json, 'has_password') ? undefined : json['has_password'],
        'home': !exists(json, 'home') ? undefined : json['home'],
        'isExternal': !exists(json, 'is_external') ? undefined : json['is_external'],
        'isCloud': !exists(json, 'is_cloud') ? undefined : json['is_cloud'],
        'isCloudDefault': !exists(json, 'is_cloud_default') ? undefined : json['is_cloud_default'],
        'isEnabled': !exists(json, 'is_enabled') ? undefined : json['is_enabled'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (json['last_seen'] === null ? null : new Date(json['last_seen'])),
        'ldap': !exists(json, 'ldap') ? undefined : json['ldap'],
        'ldapDn': !exists(json, 'ldap_dn') ? undefined : json['ldap_dn'],
        'passwordChangeRequired': !exists(json, 'password_change_required') ? undefined : json['password_change_required'],
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'shaperCeiling': !exists(json, 'shaper_ceiling') ? undefined : json['shaper_ceiling'],
        'shaperRate': !exists(json, 'shaper_rate') ? undefined : json['shaper_rate'],
        'syncId': !exists(json, 'sync_id') ? undefined : json['sync_id'],
        'totpEnabled': !exists(json, 'totp_enabled') ? undefined : json['totp_enabled'],
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'unixUsername': !exists(json, 'unix_username') ? undefined : json['unix_username'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}

export function ElementsUserReferenceToJSON(value?: ElementsUserReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


